import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect, useParams } from 'react-router';

import { useStore } from 'stores';
import * as paths from 'app-router/paths';
import Loading from 'components/Loading';
import { ErrorMessage } from 'components/Message';
import { LabeledIcon, ReloadIcon } from 'components/Icon';
import { FormCard } from 'components/Card';

import { ViewForm } from './ViewForm';

export const Page: React.FC = observer(() =>
{
  const [needToLoad, setNeedToLoad] = useState(true);
  const { featureToken } = useParams<{featureToken: string}>();
  const { uiStore, featureStore } = useStore();

  const reloadData = async () => await featureStore.getByTokenAsync(featureToken);

  useEffect(() =>
  {
    if (!featureStore.feature || featureStore.feature.token !== featureToken)
    {
      featureStore.getByTokenAsync(featureToken);
    }
    setNeedToLoad(prev => false);
  }, [featureToken, featureStore, setNeedToLoad]);

  return (
    <article className="page feature-view">
      <FormCard>
      {
        featureStore.isLoading || needToLoad
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : featureStore.isError
          ? <>
              <h1>{uiStore.labels.common.anErrorOccured}</h1>
              <ErrorMessage>{featureStore.errorMessage} <button onClick={reloadData}><LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon></button></ErrorMessage>
            </>
          : featureStore.feature
            ? <>
                <h1>{featureStore.feature.name}</h1>
                {featureStore.errorMessage ? <ErrorMessage>{featureStore.errorMessage}</ErrorMessage> : null}
                <ViewForm feature={featureStore.feature} />
              </>
            : <Redirect to={paths.buildNotFoundPath()} />
      }
      </FormCard>
    </article>
  );
});